import React from 'react'

const SvgLightbulbFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.57 15H7.438c-.266-.48-.535-.957-.808-1.432C5.526 11.628 5 10.206 5 8.5 5 4.655 8.192 2 11.997 2 15.803 2 19 4.658 19 8.5c0 1.705-.53 3.141-1.634 5.086-.345.608-.603 1.063-.797 1.414h.001zm-.583 2c-.088 3.412-1.158 4.99-3.99 4.99-2.825 0-3.902-1.597-3.99-4.99h7.98zm-.984-7c.996 0 .996-1 .996-1a4 4 0 00-4-4S11 5.001 11 6s1 .999 1 .999c1.08 0 2 .876 2 2.001 0 0 .006 1 1.003 1z'
    />
  </svg>
)

export default SvgLightbulbFilled
